var map = {
	"./Start/Start_Still.jpg": 21,
	"./chat/0_Still.jpg": 68,
	"./chat/1_Still.jpg": 69,
	"./chat/2_Still.jpg": 70,
	"./chat/3_Still.jpg": 71,
	"./excel/0_Still.jpg": 72,
	"./excel/1_Still.jpg": 73,
	"./excel/2_Still.jpg": 74,
	"./excel/3_Still.jpg": 75,
	"./excel/4_Still.jpg": 76,
	"./excel/5_Still.jpg": 77,
	"./excel/6_Still.jpg": 78,
	"./excel/7_Still.jpg": 79,
	"./excel/8_Still.jpg": 80,
	"./excel/9_Still.jpg": 81,
	"./outlook/0_Still.jpg": 82,
	"./outlook/1_Still.jpg": 83,
	"./outlook/2_Still.jpg": 84,
	"./outlook/3_Still.jpg": 85,
	"./outlook/4_Still.jpg": 86,
	"./outlook/5_Still.jpg": 87,
	"./outlook/6_Still.jpg": 88,
	"./outlook/7_Still.jpg": 89,
	"./outlook/8_Still.jpg": 90,
	"./teams/0_Still.jpg": 91,
	"./teams/1_Still.jpg": 92,
	"./teams/2_Still.jpg": 93,
	"./teams/3_Still.jpg": 94,
	"./teams/4_Still.jpg": 95,
	"./word/0_Still.jpg": 96,
	"./word/1_Still.jpg": 97,
	"./word/2_Still.jpg": 98,
	"./word/3_Still.jpg": 99,
	"./word/4_Still.jpg": 100,
	"./word/5_Still.jpg": 101,
	"./word/6_Still.jpg": 102
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67;